const actions = {
  TOGGLE_OVERLAY: 'TOGGLE_OVERLAY',
};

export default actions;
